import { Component, OnInit, ViewChild, EventEmitter, /*ngx-pagination*/ ChangeDetectionStrategy, Input, /*additional*/ OnChanges, SimpleChanges, Output, ChangeDetectorRef, ElementRef, AfterViewInit } from "@angular/core";
import { CommonDataService } from '../Services/commonDataService';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DBOperation, DataStatus, GENDER } from '../Shared/enum';
import { Global } from '../Shared/global';
import { AppContext, IComponent } from '../Shared/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, of, map, delay } from 'rxjs';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Member } from "../Models/FitnessBox/Member";
import { DatePipe } from "@angular/common";
import { PayMode } from "../Shared/invoice-enum";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { PhotoIdType } from "../Shared/fb.enum";


declare var $;
//Datatable with Pagination
//import { DataTableModule } from "angular2-datatable-serverpagination";
//TODO:Santosh
//import {NgxPaginationModule} from 'ngx-pagination';

interface IServerResponse {
  items: Member[];
  total: number;
}

@Component({
  templateUrl: './expiringSubscriptions.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'expiring-subscriptions'
})

export class ExpiringSubscriptionsComponent implements OnInit, IComponent, OnChanges {

  product: Member;
  modalTitle: string;
  modalBtnTitle: string;
  @Input('dataList') dataList: Member[];
  gridDataList: Member[] = null;
  @ViewChild('dataGrid', /* TODO: add static flag */ {}) dataGrid: jqxGridComponent;
  @ViewChild('modal', /* TODO: add static flag */ {}) modal: NgxSmartModalService;
  asyncData: Observable<Member[]>;


  //Interface Properties
  msg = "";
  dataStatus: DataStatus;
  sortData: string = "";
  indLoading = false;
  pageNum = 1;
  total = 0;
  loading = true;
  isDataRefreshed = true;
  perPage = 20;
  dbops = DBOperation.update; // Default
  //@ViewChild('modal') modal: ModalComponent;
  inputFrm: UntypedFormGroup;
  @Input('filter') filter: string = "";
  paymentModes = PayMode;
  public paymentModeEnums = [];

  @ViewChild('memberInfoPop', { static: false }) memberInfoPop: NgbPopover;
  @ViewChild('popBox') popBox: ElementRef;
  popMember: Member = new Member();
  genderList = GENDER;
  genderEnums = [];
  photoIdTypes = PhotoIdType;
  photoIdTypesEnums = [];
  salutations = ["Mr.", "Mrs.", "Ms."];
  profileImageUrl: string = 'assets/images/profile_icon_small.png';

  fromDate: Date = null;
  toDate: Date = null;
  dataFilter: string[] = [];
  selectedFilter: string = "";
  dayCount: number = null;
  defaultDayCount: number = 1;

  constructor(private router: Router,
    private fb: UntypedFormBuilder,
    private _service: CommonDataService,
    public datepipe: DatePipe,
    private appctx: AppContext,
    private elementRef: ElementRef  ) {
    this.paymentModeEnums = Object.keys(this.paymentModes).filter(f => !isNaN(Number(f)));
    this.dataFilter.push("ALL");
    this.dataFilter.push("Active");
    this.dataFilter.push("InActive");
    this.dayCount = this.defaultDayCount;
    this.genderEnums = Object.keys(this.genderList).filter(f => !isNaN(Number(f)));
    this.photoIdTypesEnums = Object.keys(this.photoIdTypes).filter(f => !isNaN(Number(f)));
  }

  ngOnChanges(changes: SimpleChanges) {
    //this.loadPageList();

  }

  ngOnInit(): void {

    this.inputFrm = this.fb.group({
      RowNumber: [''],
      ID: [''],
      Name: ['', Validators.required],
      Price: [''],
      Category: ['']
    });
    this.total = 100;
    this.fromDate = new Date();
    this.toDate = new Date(new Date().setDate(new Date().getDate() + 1));
    this.adjustFieldVisibility();
    this.Load(this.perPage, this.pageNum, Global.maxRowsForServerFetch);

  }

  adjustFieldVisibility() {
    if (this.columns &&
      this.appctx.AppConfigurations &&
      this.appctx.AppConfigurations.CustomSettings &&
      this.appctx.AppConfigurations.CustomSettings.MergeFullName
    ) {
      for (var colIdx = 0; colIdx < this.columns.length; colIdx++) {
        if (this.columns[colIdx].datafield == "LastName") {
          this.columns.splice(colIdx, 1);
        }
        else if (this.columns[colIdx].datafield == "FirstName") {
          this.columns[colIdx].text = "Full Name";
        }
      }
    }
  }

  getPage(page: number, dataList: any[]) {
    this.asyncData = Global.getPage(page, this, this.dataList);
  }

  filterData(checked: boolean) {
    this.filter = checked ? "true" : "false";
    this.Load(this.perPage, this.pageNum, Global.maxRowsForServerFetch);
  }

  public Load(perpage: number, pn: number, rowsToCache: number): void {
    this.indLoading = true;
    if (this.gridDataList)
      this.gridDataList.length = 0;

    let a: any[];
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + Global.DashboardController + this.getSearchFilters())
      .then((x) => { this.total = x.TotalCount; this.showData(x); })
      .catch(error => console.log(error));


  }

  getSearchFilters() {
    return "?dayCount=" + this.dayCount + "&fromDate=" + this.fromDate.toLocaleDateString('en-GB') + "&toDate=" + this.toDate.toLocaleDateString('en-GB') + "&filterText=expiry&sortValue=&quickTranslateMode=false&type=" + this.selectedFilter;
  }

  showData(productList: any) {
    this.indLoading = false;
    if (productList.ObjectData)
      productList = <Member[]>productList.ObjectData;
    else
      productList = [];

    this.dataList = productList;
    //this.asyncData = productList;
    //this.total = this.products.length;

    if (!this.isDataRefreshed) {
      this.getPage(this.pageNum, this.dataList);
    }

    //this.dataList.push.apply(this.dataList, productList);
    if (this.gridDataList == undefined || this.gridDataList == null) {
      var containerList = new Array(this.total);
      this.gridDataList = containerList;
    }
    var dataStart = 0, dataEnd = 0;
    if (productList != undefined && productList.length > 0) {
      dataStart = productList[0].RowNumber;
      dataEnd = productList[productList.length - 1].RowNumber;

      if (this.gridDataList[dataStart - 1] == undefined || this.gridDataList[dataEnd - 1] == undefined || this.gridDataList[dataStart - 1].RowNumber == undefined || this.gridDataList[dataStart - 1].RowNumber == 0 || this.gridDataList[dataEnd - 1].RowNumber == undefined || this.gridDataList[dataEnd - 1].RowNumber == 0) {
        let a: Member[] = <Member[]>productList;
        this.gridDataList.splice.apply(this.gridDataList, [dataStart - 1, productList.length].concat(productList));
      }
    }


    this.source.localdata = this.gridDataList;
    this.source.totalrecords = this.total;
    this.dataAdapter.dataBind();
    // passing `cells` to the `updatebounddata` method will refresh only the cells values when the new rows count is equal to the previous rows count.
    //this.myGrid.updatebounddata('cells');
  }

  getCollectionData() {
    this.Load(this.perPage, this.pageNum, Global.maxRowsForServerFetch);
  }

  dayCountChanged() {
    if (!this.dayCount || this.dayCount == 0) {
      this.dayCount = this.defaultDayCount;
    }
    this.Load(this.perPage, this.pageNum, Global.maxRowsForServerFetch);
  }

  filterChanged() {
    this.Load(this.perPage, this.pageNum, Global.maxRowsForServerFetch);
  }

  add() {
    //this.dbops = DBOperation.create;
    //this.SetControlsState(true);
    //this.modalTitle = "Add New User";
    //this.modalBtnTitle = "Add";
    //this.inputFrm.reset();
    //this.modal.open('modal', false);

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/subscription'])
    );

    let baseUrl: string = window.location.href;
    baseUrl = baseUrl.split('#')[0];
    window.open(baseUrl + "#" + url, '_self');
  }

  edit(id: number) {
    let url: string = this.router.serializeUrl(
      this.router.createUrlTree(['/subscription'])
    );

    url = url + "?id=" + id;
    let baseUrl: string = window.location.href;
    baseUrl = baseUrl.split('#')[0];
    window.open(baseUrl + "#" + url, '_self');

  }

  delete(id: number) {
    this.dbops = DBOperation.delete;
    this.SetControlsState(false);
    this.modalTitle = "Confirm to Delete?";
    this.modalBtnTitle = "Delete";
    this.product = this.dataList.filter(x => x.ID == id)[0];
    this.inputFrm.setValue(this.product);
    //this.modal.open();
  }

  SetControlsState(isEnable: boolean) {
    isEnable ? this.inputFrm.enable() : this.inputFrm.disable();
  }

  //Submit Starts
  onSubmit(formData: any) {
    //Global.onSubmit(formData, this, this._service, Global.CategoryController, true, null);
  }
  //Submit Ends

  /*JQ Widgets - Grid Starts*/

  //public source: jqwidgets.GridSource = {        
  //    localdata: this.dataList,
  //    datatype: 'array',
  //    datafields: [
  //        { name: 'Name', type: 'string' },
  //        { name: 'Price', type: 'int' },
  //        { name: 'Category', type: 'string' }
  //    ],
  //    totalrecords: 1000000
  //};
  //---------------------------------------------------------------------------------------


  source: any =
    {
      localdata: this.gridDataList,
      datatype: 'array',
      datafields: [
        { name: 'ID', type: 'int' },
        { name: 'FirstName', type: 'string' },
        { name: 'LastName', type: 'string' },
        { name: 'Contact1', type: 'string' },
        { name: 'Contact2', type: 'string' },
        { name: 'UserName', type: 'string' },
        { name: 'IdentityId', type: 'string' },
        { name: 'MembershipStartDate', type: 'date' },
        { name: 'MembershipExpiryDate', type: 'date' },
        { name: 'TotalAmount', type: 'decimal' },
        { name: 'PaidAmount', type: 'decimal' },
        { name: 'BalanceAmount', type: 'decimal' },
        { name: 'PaidBy', type: 'string' },
        { name: 'InvoiceDetails', type: 'MemberInvoice' },
        { name: 'UserMemberships', type: 'UserMembershipPlan' },
        { name: 'AssignedTrainer', type: 'Employee' },
        { name: 'IsActive', type: 'boolean' }

      ],
      totalrecords: 0
    }
  getWidth(): any {
    if (document.body.offsetWidth < 850) {
      return '90%';
    }

    return 850;
  }
  dataAdapter: any = new jqx.dataAdapter(this.source);
  rendergridrows = (params: any): any[] => {
    let getNewPage: boolean = false;
    if (this.gridDataList != undefined &&
      (this.gridDataList[params.startindex] == undefined || this.gridDataList[params.startindex].RowNumber == undefined
        || this.gridDataList[params.endindex] == undefined || this.gridDataList[params.endindex].RowNumber == undefined)) {
      getNewPage = true;
    }

    if (this.dataList != undefined && getNewPage) {
      let pgSize: number = this.dataGrid.pagesize();
      this.getPage(Math.ceil(params.endindex / pgSize), this.dataList);
    }

    let data = this.gridDataList != undefined ? this.gridDataList : [{}]; // this.generateData(params.startindex, params.endindex);
    return data;
  }
  //{ text: 'Active', datafield: 'IsActive', cellsrenderer: this.cellsrenderer },
  public columns: jqwidgets.GridColumn[] = [
    //{ text: 'Invoice Id', datafield: 'InvoiceNumber', width: 70, cellsrenderer: this.formatInvoiceDetail },
    { text: 'Reg Id', datafield: 'IdentityId', width: 50, cellsrenderer: this.formatInvoiceDetail },
    { text: 'First Name', datafield: 'FirstName', minwidth: 80 },
    { text: 'Last Name', datafield: 'LastName', width: 150 },
    { text: 'Contact', datafield: 'Contact1', width: 100 },    
    /* { text: 'User Name', datafield: 'UserName', width: 100 },  */
    { text: 'Package', datafield: 'PackageName', minwidth: 90, cellsrenderer: this.formatInvoiceDetail },
    { text: 'Start Date', datafield: 'MembershipStartDate', width: 80, cellsrenderer: this.formatInvoiceDetail },
    { text: 'End Date', datafield: 'MembershipExpiryDate', width: 80, cellsrenderer: this.formatInvoiceDetail },
    { text: 'Duration', datafield: 'DurationDays', width: 70, cellsrenderer: this.formatInvoiceDetail },
    { text: 'Remaining', datafield: 'BalanceDays', width: 80, cellsrenderer: this.formatInvoiceDetail },
    //{ text: 'Paid By', datafield: 'PaidBy', width: 60, cellsrenderer: this.formatInvoiceDetail },
    //{ text: 'Total', datafield: 'TotalAmount', width: 50, cellsrenderer: this.formatInvoiceDetail },
    /*{ text: 'Total Paid', datafield: 'TotalPaid', width: 60, cellsrenderer: this.formatInvoiceDetail },*/
    //{ text: 'Paid', datafield: 'PaidAmount', width: 50, cellsrenderer: this.formatInvoiceDetail },
    //{ text: 'Balance', datafield: 'BalanceAmount', width: 60, cellsrenderer: this.formatInvoiceDetail },
    { text: 'Active', datafield: 'IsActive', width: 50, cellsrenderer: this.formatInvoiceDetail },
    { text: '', datafield: 'View', width: 60, cellsrenderer: this.formatInvoiceDetail },
    {
      text: '', datafield: 'Renew', width: 40, columntype: 'button', sortable: false,
      cellsrenderer: (): string => {
        return '<i title="Renew" class="fa fa-refresh fa-spin fa-fw editButton"></i>';
      },
      buttonclick: (row: number): void => {
        var editrow = row;
        let dataRecord = <Member>this.dataGrid.getrowdata(editrow);
        if (dataRecord) {
          this.edit(dataRecord.MembershipId);
        }
        else {
          alert('Error while selecting Subscription')
        }

      }
    }
  ];

  cellsrenderer(row, columnfield, value, defaulthtml, columnproperties): string {
    if (value) {
      return defaulthtml.replace("[object Object]", value.Name);
    }
  }

  formatInvoiceDetail(index: number, columnfield: string, value: any, defaultvalue: any, column: any, rowdata: any): string {
    if (rowdata.InvoiceDetails != undefined) {
      if (columnfield == "MembershipStartDate") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + ((<Member>rowdata).UserMemberships && (<Member>rowdata).UserMemberships.length > 0 && (<Member>rowdata).UserMemberships[0].PlanStartDate ? new Date((<Member>rowdata).UserMemberships[0].PlanStartDate).toLocaleDateString('en-GB') : new Date((<Member>rowdata).MembershipStartDate).toLocaleDateString('en-GB')) + " </div>";
      }
      else if (columnfield == "MembershipExpiryDate") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + ((<Member>rowdata).UserMemberships && (<Member>rowdata).UserMemberships.length > 0 && (<Member>rowdata).UserMemberships[0].PlanEndDate ? new Date((<Member>rowdata).UserMemberships[0].PlanEndDate).toLocaleDateString('en-GB') : new Date((<Member>rowdata).MembershipExpiryDate).toLocaleDateString('en-GB')) + " </div>";
      }
      else if (columnfield == "InvoiceNumber") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + (rowdata.InvoiceDetails.length > 0 ? rowdata.InvoiceDetails[0].InvoiceNumber : 0) + " </div>";
      }
      else if (columnfield == "TotalAmount") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + (rowdata.InvoiceDetails.length > 0 ? rowdata.InvoiceDetails[0].NetTotal : 0) + " </div>";
      }
      else if (columnfield == "BalanceAmount") {
        return "<div class='jqx-grid-cell-left-align " + (rowdata.InvoiceDetails.length > 0 && rowdata.InvoiceDetails[0].BalanceAmount > 0 ? "red" : "") + "' style='margin-top: 10px; ' > " + (rowdata.InvoiceDetails.length > 0 ? rowdata.InvoiceDetails[0].BalanceAmount : 0) + " </div>";
      }
      else if (columnfield == "TotalPaid") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + (rowdata.InvoiceDetails.length > 0 ? rowdata.InvoiceDetails[0].PaidAmount : 0) + " </div>";
      }
      else if (columnfield == "PaidAmount") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + (rowdata.InvoiceDetails.length > 0 ? rowdata.InvoiceDetails[0].PaidAmount : 0) + " </div>";
      }
      else if (columnfield == "AssignedTrainer") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + rowdata.AssignedTrainer?.FirstName + " </div>";
      }
      else if (columnfield == "IsActive") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + (rowdata.IsActive ? "Yes" : "No") + " </div>";
      }
      else if (columnfield == "PaidBy") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + (rowdata.InvoiceDetails.length > 0 ? (rowdata.InvoiceDetails[0].PaidBy == 0 ? "NONE" : (rowdata.InvoiceDetails[0].PaidBy == 1 ? "CASH" : (rowdata.InvoiceDetails[0].PaidBy == 2 ? "ONLINE" : (rowdata.InvoiceDetails[0].PaidBy == 3 ? "CARD" : (rowdata.InvoiceDetails[0].PaidBy == 4 ? "SODEXO" : "CHEQUE"))))) : "NONE") + " </div>";
      }
      else if (columnfield == "PackageName") {
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + ((<Member>rowdata).UserMemberships && (<Member>rowdata).UserMemberships.length > 0 ? (<Member>rowdata).UserMemberships[0].Name : " " ) + " </div>";
      }
      else if (columnfield == "DurationDays") {
        let n: number = (1000 * 3600 * 24);
        let d: number = 0;
        //let d: number = rowdata.UserMemberships != undefined && rowdata.UserMemberships.length > 0 ? rowdata.UserMemberships[0].PlanDurationDays : 0;
        try { d = Math.round((new Date(rowdata.MembershipExpiryDate).getTime() - new Date(rowdata.MembershipStartDate).getTime()) / n); } catch (e) { }
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + d + " </div>";
      }
      else if (columnfield == "BalanceDays") {
        let n: number = (1000 * 3600 * 24);
        let d: number = 0;
        if (rowdata.UserMemberships != undefined && rowdata.UserMemberships.length > 0) {
          d = rowdata.UserMemberships != undefined && rowdata.UserMemberships.length > 0 ? rowdata.UserMemberships[0].PlanDurationDays : 0;
          try { d = Math.round((new Date(new Date((<Member>rowdata).UserMemberships[0].PlanEndDate).setHours(0, 0, 0, 0)).getTime() - new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / n); } catch (e) { }
          return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + d + " </div>";
        }
        else {
          try { d = Math.round((new Date(new Date(rowdata.MembershipExpiryDate).setHours(0, 0, 0, 0)).getTime() - new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / n); } catch (e) { }
          return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > " + d + " </div>";
        }

      }
      else if (columnfield == "View") {
        //return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > <a  href='/Index#/subscriptions?search=" + ((<Member>rowdata).FirstName + " " + ((<Member>rowdata).LastName ? (<Member>rowdata).LastName : "")) + "'>Details</a> </div>";
        return "<div class='jqx-grid-cell-left-align' style='margin-top: 10px;' > <a  href='/Index#/subscriptions?search=" + (<Member>rowdata).IdentityId + "'>Details</a> </div>";
      }
      else if (columnfield == "IdentityId") {
        return "<div class='jqx-grid-cell-left-align pop-element' style='margin-top: 10px;cursor:pointer;' index='" + index + "' > " + rowdata.IdentityId + " </div>";
      }
    }

  }

  onPageSizeChanged(event: any): void {
    this.perPage = event.args.pagesize;
  }


  dataGridOnSort(event: any): void {
    let sortDetails = "";
    let sortInfo = event.args.sortinformation;
    for (let i: number = 0; i < sortInfo.sortcolumns.length; i++) {
      sortDetails += sortInfo.sortcolumns[i].dataField + " " + (sortInfo.sortcolumns[i].ascending ? 'ASC' : 'DESC')
      if (i != sortInfo.sortcolumns.length - 1) {
        sortDetails += ",";
      }
    }

    this.sortData = sortDetails;
    let sortdirection = sortInfo.sortdirection.ascending ? 'ASC' : 'DESC';
    if (sortDetails == "") {
      sortdirection = 'null';
    }
    this.gridDataList.length = 0;
    this.Load(this.perPage, this.pageNum, Global.maxRowsForServerFetch);
  };

  filterChange(): void {
    this.gridDataList.length = 0;
    this.Load(this.perPage, this.pageNum, Global.maxRowsForServerFetch);
  }

  cnt: number = 0;
  Bindingcomplete(event: any): void {
    this.cnt = this.cnt + 1;
    if (this.cnt > 1) {
      setTimeout(() => {
        (<NodeList>this.elementRef.nativeElement.querySelectorAll('.pop-element')).forEach((elem, i) => {
          elem.addEventListener('click', (p) => {
            if (p instanceof MouseEvent) {
              this.showMemberInfoPop(p, elem);
            }
          });
          elem.addEventListener('mouseleave', (p) => {
            this.hideMemberInfoPop();
          });
          //elem.addEventListener('click', (p) => {
          //  if (p instanceof MouseEvent) {
          //    this.showMemberInfoPop(p, i);
          //  }
          //});
        });
      }, 1000);
    }
  }

  showMemberInfoPop(obj: MouseEvent, elem: any) {
    debugger
    this.memberInfoPop.close();
    let idx: number = eval(elem.attributes.index.value);
    this.popMember = <Member>this.dataGrid.getrowdata(idx);
    this.popMember = this.processMemberObj(this.popMember);
    this.setProfileImage(this.popMember);
    this.memberInfoPop.open();

    let mLeft: string = this.elementRef.nativeElement.ownerDocument.querySelector(".mat-sidenav-content").style.marginLeft;
    let marginLeftToSubtract = 0;
    if (mLeft != "") {
      marginLeftToSubtract = eval(this.elementRef.nativeElement.ownerDocument.querySelector(".mat-sidenav-content").style.marginLeft.replace("px", ""));
    }
    marginLeftToSubtract = marginLeftToSubtract - 30;
    this.popBox.nativeElement.style.left = (obj.pageX - marginLeftToSubtract) + "px";
    this.popBox.nativeElement.style.top = (obj.pageY - 75) + "px";
  }

  hideMemberInfoPop() {
    this.memberInfoPop.close();
    this.popMember = new Member();
  }

  processMemberObj(member: Member) {
    member.DateOfBirth = Global.TransformDateObject(member.DateOfBirth);
    member.MembershipStartDate = Global.TransformDateObject(member.MembershipStartDate);
    member.MembershipExpiryDate = Global.TransformDateObject(member.MembershipExpiryDate);
    return member;
  }

  setProfileImage(member: Member) {
    if (member.UserImages) {
      var profileImg = member.UserImages.find(img => img.IsCoverPhoto == true);
      if (profileImg) {
        this.profileImageUrl = profileImg.ImagePath;
      }
      else {
        this.profileImageUrl = "assets/images/profile_icon_small.png";
      }
    }
    else {
      this.profileImageUrl = "assets/images/profile_icon_small.png";
    }
  }

  pagerrenderer = () => {
    let element = $("<div style='margin-top: 5px; width: 100%; height: 100%;'></div>");
    let paginginfo = this.dataGrid.getpaginginformation();
    for (var i = 0; i < paginginfo.pagescount; i++) {
      // add anchor tag with the page number for each page.
      let anchor = $("<a style='padding: 5px; color: blue;'>" + i + "</a>");
      anchor.appendTo(element);
      anchor.click((event) => {
        // go to a page.
        let pagenum = parseInt($(event.target).text());
        this.dataGrid.gotopage(pagenum);
      });
    }
    return element;
  }
  /*JQ Widgets - Grid Ends*/
}

function activator<T extends Member>(type: { new(): T; }): T {
  return new type();
}
